import fetchWrapper from '@/http/fetchWrapper';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';
import { api } from '@http/constants';
import { useMutation } from '@tanstack/react-query';
import { useNotification } from '@eye-able/ui';

export interface PostOfferRequestResponse {
  message: string;
}

export function usePostOfferRequest() {
  const { t } = useInlineTranslation();
  const notification = useNotification();

  return useMutation({
    mutationFn: (message: string) =>
      fetchWrapper.post<PostOfferRequestResponse>(api.offerRequest, {
        message,
      }),
    onSuccess: () => {
      notification.success(t('supportRequestSent'));
    },
  });
}
